/* MENSAJE WHATSAPP ALEATORIO | INICIO */

document.addEventListener("DOMContentLoaded", function(){

    const mensajes = [
        "Quiero una sala con promoción",
        "Quiero una recámara con promoción",
        "Quiero un antecomedor con promoción"
    ];

    const elementoMensaje = document.getElementById("id-boton-whatsapp-mensaje");

    function mostrarMensaje(){

        const mensajeAleatorio = mensajes[Math.floor(Math.random() * mensajes.length)];

        elementoMensaje.textContent = mensajeAleatorio;

        elementoMensaje.classList.add("activo");

        setTimeout(() => {
            elementoMensaje.classList.remove("activo");
        }, 4000);

    }

    // primera aparición
    setTimeout(mostrarMensaje, 1500);

    // repetir cada cierto tiempo
    setInterval(mostrarMensaje, 8000);

});

/* MENSAJE WHATSAPP ALEATORIO | FINAL */